import { Flex } from "@mantine/core";

import Layout from "../../components/Layout/Layout";
import Title from "../../components/Title/Title.tsx";
import { useTenantId } from "../../hooks/useTenantId.ts";
import { useCurrentUserContext } from "../../providers/CurrentUserProvider.tsx";
import { isBababosSuperAdmin } from "../../utils/user.ts";
import Page404 from "../404/Page404.tsx";
import { PasswordForm } from "./PasswordForm/PasswordForm.tsx";
import { ProfileSettingForm } from "./ProfileSettingForm.tsx";

export default function ProfileSettingPage() {
  const { user } = useCurrentUserContext();
  const { tenantId } = useTenantId();

  if (isBababosSuperAdmin(user) && Number(tenantId) !== user?.tenantId) {
    return <Page404 />;
  }

  return (
    <Layout>
      <Flex direction="column" gap={{ base: 24, sm: 20 }}>
        <Flex gap={20} justify="space-between">
          <Flex gap={20}>
            <Title size="h1">Profile Settings</Title>
          </Flex>
        </Flex>
        <Flex gap={24} direction="column">
          <ProfileSettingForm />
          <PasswordForm />
        </Flex>
      </Flex>
    </Layout>
  );
}
